body {
  padding-top: 75px;
}
.home-page .thumbnail {
  text-align: center;
}
.navbar-brand .logo {
  height: 44px;
  margin-top: -12px;
}



// WEBPACK FOOTER //
// ./~/autoprefixer-loader!./~/stylus-loader!./src/styles/index.styl